import styled from "react-emotion";
import { themeGet } from "styled-system";

export const Container = styled("div")`
  width: 100%;
  height: 100%;
  background: ${themeGet("colors.greyLighter")};
  display: flex;
  align-items: center;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/components/views/login/style.js